import TermsAndConditionsComponent from "@/features/terms-and-conditions-page/components/TermsAndConditionsPage";
import React from "react";

export const TermsAndConditionsPage = () => {
  return (
    <div>
      <TermsAndConditionsComponent />
    </div>
  );
};
